import { render, staticRenderFns } from "./AddFactureLibreNew.vue?vue&type=template&id=2b99fe1a&scoped=true&"
import script from "./AddFactureLibreNew.vue?vue&type=script&lang=js&"
export * from "./AddFactureLibreNew.vue?vue&type=script&lang=js&"
import style0 from "./AddFactureLibreNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddFactureLibreNew.vue?vue&type=style&index=1&id=2b99fe1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b99fe1a",
  null
  
)

export default component.exports